import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df67e5f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-calendar" }
const _hoisted_2 = { class: "weekdays" }
const _hoisted_3 = { class: "day-grid" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "has-appointments" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, _toDisplayString(this.$mhat("CalendarDays.SundayAbbreviation")), 1),
        _createElementVNode("div", null, _toDisplayString(this.$mhat("CalendarDays.MondayAbbreviation")), 1),
        _createElementVNode("div", null, _toDisplayString(this.$mhat("CalendarDays.TuesdayAbbreviation")), 1),
        _createElementVNode("div", null, _toDisplayString(this.$mhat("CalendarDays.WednesdayAbbreviation")), 1),
        _createElementVNode("div", null, _toDisplayString(this.$mhat("CalendarDays.ThursdayAbbreviation")), 1),
        _createElementVNode("div", null, _toDisplayString(this.$mhat("CalendarDays.FridayAbbreviation")), 1),
        _createElementVNode("div", null, _toDisplayString(this.$mhat("CalendarDays.SaturdayAbbreviation")), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datesForMonth, (date, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "day",
            key: index
          }, [
            date
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(_ctx.getDateClass(date)),
                  onClick: ($event: any) => (_ctx.selectDate(date))
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", null, _toDisplayString(date.date()), 1),
                    _hoisted_6
                  ])
                ], 10, _hoisted_4))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}